// extracted by mini-css-extract-plugin
export default {"container":"PreviewInvoice_container__CdYZM","contents":"PreviewInvoice_contents__ddAuI"};